import React from "react";
import "./Software.css";
function Software(){

    return(
        <div className="contents">
  <div className="container">
  {/* <!-- Row 1: Three Cards --> */}
  <div className="row justify-content-center g-4">
    <div className="col-md-4">
      <div className="cardid card border border-dark">

                      <div className="corner-circle"></div>

        <div className="card-body">
          <h5 className="card-title">
              <img src="customsoft.png" alt="Logo"/>
            Custom Software Development</h5>
          <p className="card-text"><br/>We develop fully customized software solutions<br/>
           that are perfectly aligned with<br/>
            your business goals and operations. <br/> Whether you
            need a CRM,
           billing system,<br/>
            or workflow automation tool,<br/>
            we deliver software that simplifies<br/>
             your processes and improves productivity.<br/>
              Our team ensures the software is scalable,<br/>
               secure, and built for long-term success.</p>
        </div>
      </div>
    </div>
    <div className="col-md-4">
      <div className=" cardid card  border border-dark">

                      <div className="corner-circle "></div>

        <div className="card-body">
         <h5 className="card-title">
        <img src="webmobile.png" alt="Logo"/>
            Web & Mobile Application Development</h5>
          <p className="card-text">We create logos that are unique, memorable, and aligned with your brand identity. Our designs are clean, scalable, and made to stand out whether on a business card or billboard. Offering affordable custom logo design services in Coimbatore, we focus on creativity and clarity to ensure your brand leaves a lasting mark. Need a logo that speaks for your business? Let us design it with purpose and professionalism.</p>
        </div>
      </div>
    </div>
    <div className="col-md-4">
      <div className="cardid card  border border-dark">

                              <div className="corner-circle "></div>

        <div className="card-body">
          <h5 className="card-title">
          <img src="cloudbased.png" alt="Logo"/>
             Cloud-Based Solutions</h5>
          <p className="card-text"><br/>
          We create powerful cloud-based applications hosted on secure platforms like AWS, Azure, and Google Cloud. Our cloud solutions are designed to offer high scalability, remote access, and uninterrupted performance.<br/>
           Whether you’re managing data, running services, or collaborating in real time,<br/>
            our cloud applications keep you connected and efficient, from anywhere.</p>
        </div>
      </div>
    </div>
  </div>

  <div className="row justify-content-center g-4 mt-3">
    <div className="col-md-4">
      <div className="cardid card  border border-dark">

                              <div className="corner-circle "></div>

        <div className="card-body">
          <h5 className="card-title">
          <img src="api.png" alt="Logo"/>
            API & System Integration</h5>
          <p className="card-text">We develop secure and well-documented APIs that help connect your software with third-party tools, payment gateways, CRMs, and more. From automating workflows to enhancing features, our integration services help your systems talk to each other smoothly. We make sure everything works together in real-time, without lag or failure.</p>
        </div>
      </div>
    </div>
    <div className="col-md-4">
      <div className="cardid card  border border-dark">

                              <div className="corner-circle "></div>

        <div className="card-body">
          <h5 className="card-title">
          <img src="softtest.png" alt="Logo"/>
           Software Testing & Maintenance</h5>
          <p className="card-text">Our job doesn’t stop at development—we ensure your software remains bug-free, fast, and fully functional through continuous testing and maintenance. We offer ongoing support, regular updates, and security patches to keep your software running smoothly. With us, your system is always up-to-date and ready for business.</p>
        </div>
      </div>
    </div>
  </div>
</div>


<button type="button" className="exitbutton btn btn-primary" data-bs-toggle="modal" data-bs-target="#exampleModal">
  Move to Previous
</button>


<div class="modal fade" id="exampleModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="exampleModalLabel">Exit page</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body">
      Are You Really want to Exit this page..
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">No</button>
        <button type="button" class="btn btn-primary">Yes</button>
      </div>
    </div>
  </div>
</div>


        </div>
    )

}
export default Software;